<template>
    <div v-if="expandAll" class="container mt-4">
      <div class="date-header bg-light text-center py-2">
        <strong>{{currentBottomTab}}</strong>
      </div>
  
      <div v-for="(item, index) in timelineData"
        :key="index" class="task-item d-flex align-items-center border-bottom py-3"
        :class="{ 'task-item-hover': hoveredItemIndex === index }"
        @mouseenter="hoveredItemIndex = index"
        @mouseleave="hoveredItemIndex = null"
        @click="openDetailsModal(item)"
        >
        <div class="icon d-flex align-items-center justify-content-center me-3">
          <span
            :class="getIconClass(item.type)"
            class="icon-symbol d-flex align-items-center justify-content-center"
          >
            {{ getIcon(item.type) }}
          </span>
        </div>
        <div class="content flex-grow-1">
          <p class="mb-0 fw-bold text-capitalize">{{ item.type }}</p>
          <p v-if="item.subject" class="mb-0 text-muted">
            Subject: <strong>{{ item.subject }}</strong>
          </p>
          <p v-if="item.contact_person" class="mb-0 text-muted">
            Contact Person: <strong>{{ item.contact_person }}</strong>
          </p>
          <p v-if="item.title" class="mb-0 text-muted">
            Task Title: <strong>{{ item.title }}</strong>
          </p>
          <p v-if="item.task_type" class="mb-0 text-muted">
            Task Type: <strong>{{ item.task_type }}</strong>
          </p>
          <p v-if="item.description" class="mb-0 text-muted">
            Description: <strong>{{ item.description }}</strong>
          </p>
          <p v-if="item.assigned_to" class="mb-0 text-muted">
            Assigned To: <a href="#" class="text-decoration-none">{{ item.assigned_to }}</a>
          </p>
        </div>
        <div class="meta text-end text-muted">
          <p class="mb-0 small">
            Created: <a href="#" class="text-decoration-none">
              {{item.user_name}} </a> at {{ formatDate(item.created_at) }}
          </p>
        </div>
      </div>

      <!-- Modal -->
      <div
        v-if="showModal"
        class="modal fade show d-block"
        tabindex="-1"
        role="dialog"
        aria-labelledby="detailsModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="detailsModalLabel">Details</h5>
              <button type="button" class="btn-close" @click="closeDetailsModal"></button>
            </div>
            <div class="modal-body">
              <p><strong>Type:</strong> {{ selectedItem.type }}</p>
              <p v-if="selectedItem.subject"><strong>Mail Subject:</strong> {{ selectedItem.subject }}</p>
              <p><strong>Description:</strong> {{ selectedItem.description }}</p>
              <p v-if="selectedItem.log_type"><strong>Log Type:</strong> {{ selectedItem.log_type }}</p>
              <p v-if="selectedItem.start_date"><strong>Start Date:</strong> {{ selectedItem.start_date }}</p>
              <p v-if="selectedItem.start_time"><strong>Start Time:</strong> {{ selectedItem.start_time }}</p>
              <p v-if="selectedItem.due_date"><strong>End Date:</strong> {{ selectedItem.due_date }}</p>
              <p v-if="selectedItem.due_time"><strong>End Time:</strong> {{ selectedItem.due_time }}</p>
              <p v-if="selectedItem.priority"><strong>Priority:</strong> {{ selectedItem.priority }}</p>
              <p v-if="selectedItem.assign_to && selectedItem.assign_to.length > 0"><strong>Assign To: </strong>
                <span v-for="(assign, i) in selectedItem.assign_to" :key="i">
                  {{ assign.name }}, 
                </span>
              </p>
              <p v-if="selectedItem.created_at"><strong>Created:</strong> {{ formatDate(selectedItem.created_at) }}</p>

              <!-- Display files if available -->
              <div v-if="selectedItem.attachments && selectedItem.attachments.length > 0">
                <strong>Files:</strong>
                <div class="d-flex flex-wrap gap-2 mt-2">
                  <div
                    v-for="(file, index) in selectedItem.attachments"
                    :key="index"
                    class="file-item text-center"
                  >
                    <file-preview-check :file="file"></file-preview-check>
                  </div>
                </div>
              </div>

              <!-- task file -->
              <div v-if="selectedItem.task_file">
                <strong>File:</strong>
                <div class="d-flex flex-wrap gap-2 mt-2">
                  <div class="file-item text-center">
                    <file-preview-check :file="selectedItem.task_file"></file-preview-check>
                  </div>
                </div>
              </div>

              <!-- email file -->
              <div v-if="selectedItem.email_file">
                <strong>File:</strong>
                <div class="d-flex flex-wrap gap-2 mt-2">
                  <div class="file-item text-center">
                    <file-preview-check :file="selectedItem.email_file"></file-preview-check>
                  </div>
                </div>
              </div>

            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" @click="closeDetailsModal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "TaskList",
    props: {
      timelineData: {
        type: Array,
        required: true,
      },
      currentBottomTab: {
        type: String,
        required: true,
      },
      expandAll: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        hoveredItemIndex: null,
        showModal: false,
        selectedItem: {},
      };
    },
    watch: {
    },
    methods: {
      getIcon(type) {
        const icons = {
          note: "📝",
          "log activity": "📋",
          task: "✔️",
          sms: "📩",
          email: "📧",
          file: "📁",
        };
        return icons[type.toLowerCase()] || "❓";
      },
      getIconClass(type) {
        const classes = {
          note: "note-icon",
          "log activity": "log-icon",
          task: "task-icon",
          sms: "sms-icon",
          email: "email-icon",
          file: "file-icon",
        };
        return classes[type.toLowerCase()] || "default-icon";
      },

      formatDate(date) {
        const options = {
          day: "2-digit",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        };
        return new Intl.DateTimeFormat("en-US", options).format(new Date(date));
      },

      openDetailsModal(item) {
        console.log(item,'asdasdasdasdasd')
        this.selectedItem = item;
        this.showModal = true;
      },
      closeDetailsModal() {
        this.showModal = false;
        this.selectedItem = {};
      },

    },

  };
  </script>
  
  <style scoped>
  .container {
    max-height: 500px;
    overflow-y: auto;
  }

  .date-header {
    /* background-color: #e6f4ff;
    font-size: 1.1rem; */
    background-color: #e6f4ff !important; /* Light blue background color */
    color: #000; /* Text color for contrast */
    font-size: 1.1rem; /* Slightly larger font */
    font-weight: bold;
  }
  
  .task-item {
    display: flex;
    align-items: center;
  }
  
  .icon {
    width: 50px; /* Fixed width for consistent spacing */
    height: 50px; /* Fixed height */
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  
  .icon-symbol{
    font-size: 1.5rem;
    color: #6c757d;
  }

  .content{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  /* .note-icon,
  .call-icon {
    font-size: 1.5rem;
    color: #6c757d;
  } */
  
  p {
    margin-bottom: 0.25rem;
  }
  
  a {
    color: #0056b3;
  }
  
  a:hover {
    text-decoration: underline;
  }

  .task-item-hover {
    background-color: rgba(0, 123, 255, 0.1); /* Light blue highlight */
    cursor: pointer;
  }

  .modal {
    background-color: rgba(0, 0, 0, 0.5); /* Modal overlay */
  }

  .modal .modal-dialog {
    margin-top: 10%;
  }
  </style>
  